import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1, 1),
    minHeight: 80,
    marginBottom: theme.spacing(1)
  }
}));
